import dayjs from "dayjs";

import { isDateInRange } from "@/utils/filterDateByRange";
import { getTransactionId } from "@/utils/transactionRecord";

import type { AuctionCarTransaction, AuctionsChartPayload } from "@/types/auctions";
import type { DatesRange } from "@/types/entity";

export function transactionsToChartData(
  transactions: AuctionCarTransaction[]
): AuctionsChartPayload[] {
  return [...transactions]
    .sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())
    .map((transaction) => ({
      id: getTransactionId(transaction),
      date: transaction.date,
      value: transaction.hammer_price,
      condition: transaction.condition,
      result: transaction.result ?? null,
      outlier: transaction.outlier,
      replica: transaction.replica,
    }));
}

export function normalizeData(data: AuctionsChartPayload[]) {
  return data.map((item) => ({
    ...item,
    date: dayjs(item.date).unix(),
    outlier: item.outlier ?? false,
    replica: item.replica ?? false,
  }));
}

export function filterChartPayloadByDateRange(
  data: AuctionsChartPayload[],
  dateRange?: DatesRange
) {
  if (!dateRange) return data;
  return data.filter((item) => isDateInRange(item.date, dateRange));
}

export function filterChartData(
  data: ReturnType<typeof normalizeData>,
  options: { showOutliers: boolean; showReplicas: boolean }
) {
  return data.filter((item) => {
    if (item.outlier && !options.showOutliers) return false;
    if (item.replica && !options.showReplicas) return false;
    return true;
  });
}
